import styled from 'styled-components/macro';
import { StandardBottomMargin } from '../../../shared-styles';
import { FlexJustifyCenter, FlexAlignCenter } from '../../../shared-styles/flex';

export const Container = styled.div`
  ${FlexJustifyCenter}
  ${FlexAlignCenter}
  flex-direction: column;
  width: 100%;
  margin-top: 260px;
`;

export const Title = styled.p`
  ${StandardBottomMargin}
  font-size: ${({ theme }) => theme.typography.sizes.extraLarge};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  color: ${({ theme }) => theme.palette.blue[100]};
`;

export const Message = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.h2};
`;
